import { render, staticRenderFns } from "./OurService.vue?vue&type=template&id=5f7ac186&scoped=true&"
import script from "./OurService.vue?vue&type=script&lang=js&"
export * from "./OurService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ac186",
  null
  
)

export default component.exports